enum SelectorCombinatorEnum {
	descendant = 'descendant',
	child = 'child',
	adjacentSibling = 'adjacentSibling'
}

export default SelectorCombinatorEnum;
